import { Controller } from "@hotwired/stimulus"

// Generic dispatch trigger: fires a namespaced document event that a
// modal / drawer / panel listens for in its own markup. The prefix and
// event name arrive as action params, so one controller serves every
// "button opens a thing elsewhere" pairing:
//
//   data-action="click->trigger#fire"
//   data-trigger-prefix-param="library-drawer"
//   data-trigger-event-param="toggle"
export default class extends Controller {
  fire(event: Event & { params: { prefix: string; event: string } }) {
    event.preventDefault()
    this.dispatch(event.params.event, { prefix: event.params.prefix })
  }
}
